// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__JXPqB","fileDisabled":"File_fileDisabled__3VDD_"};